/**
 * Live Search - Destaque Equipamentos
 * Integração nativa com header-desktop.liquid e header-mobile.liquid
 *
 * INSTALAÇÃO:
 * 1. Shopify Admin → Online Store → Themes → Edit code
 * 2. Em Assets → Add a new asset → Create blank file → nome: live-search.js
 * 3. Cole este conteúdo e salve
 * 4. Abra theme.liquid e adicione ANTES de </body>:
 *    {{ 'live-search.js' | asset_url | script_tag }}
 */

(function () {
  'use strict';

  // ─── CONFIGURAÇÕES ────────────────────────────────────────────────────────
  var CONFIG = {
    minChars: 2,       // Mínimo de caracteres para disparar a busca
    maxResults: 6,     // Máximo de produtos no dropdown
    debounceMs: 280,   // Delay após parar de digitar (ms)
  };
  // ─────────────────────────────────────────────────────────────────────────

  // ─── UTILITÁRIOS ─────────────────────────────────────────────────────────
  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  function formatMoney(cents) {
    return 'R$\u00a0' + (cents / 100)
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function escapeHtml(str) {
    return str.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlightMatch(text, query) {
    var safe = escapeHtml(text);
    var escaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return safe.replace(new RegExp('(' + escaped + ')', 'gi'), '<mark>$1</mark>');
  }
  // ─────────────────────────────────────────────────────────────────────────

  // ─── CSS INJETADO ─────────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('de-live-search-css')) return;
    var style = document.createElement('style');
    style.id = 'de-live-search-css';
    style.textContent = [
      /* Wrapper — precisa ser position:relative para o dropdown se ancorar */
      '.de-ls-wrapper { position: relative; flex: 1; }',

      /* O dropdown em si */
      '.de-ls-dropdown {',
      '  position: absolute;',
      '  top: calc(100% + 4px);',
      '  left: 0;',
      '  right: 0;',
      '  background: #fff;',
      '  border-radius: 6px;',
      '  box-shadow: 0 8px 28px rgba(0,0,0,0.14);',
      '  z-index: 9999;',
      '  overflow: hidden;',
      '  max-height: 420px;',
      '  overflow-y: auto;',
      '  /* Animação de entrada */',
      '  opacity: 0;',
      '  transform: translateY(-6px);',
      '  pointer-events: none;',
      '  transition: opacity 0.18s ease, transform 0.18s ease;',
      '}',

      /* Estado visível */
      '.de-ls-dropdown.de-ls-open {',
      '  opacity: 1;',
      '  transform: translateY(0);',
      '  pointer-events: all;',
      '}',

      /* Cabeçalho interno */
      '.de-ls-header {',
      '  padding: 8px 14px 6px;',
      '  font-size: 10px;',
      '  font-weight: 700;',
      '  letter-spacing: 0.1em;',
      '  text-transform: uppercase;',
      '  color: #aaa;',
      '  border-bottom: 1px solid #f0f0f0;',
      '  font-family: var(--font-heading-family, "Oswald", sans-serif);',
      '}',

      /* Item produto */
      '.de-ls-item {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 10px;',
      '  padding: 9px 14px;',
      '  text-decoration: none;',
      '  color: var(--color-text, #1a1a1a);',
      '  transition: background 0.12s;',
      '  cursor: pointer;',
      '  border-bottom: 1px solid #f9f9f9;',
      '}',
      '.de-ls-item:last-of-type { border-bottom: none; }',
      '.de-ls-item:hover, .de-ls-item.de-ls-active { background: #f5f5f5; }',

      /* Imagem do produto */
      '.de-ls-img {',
      '  width: 44px;',
      '  height: 44px;',
      '  object-fit: contain;',
      '  border-radius: 4px;',
      '  background: #f9f9f9;',
      '  flex-shrink: 0;',
      '  padding: 3px;',
      '}',
      '.de-ls-img-ph {',
      '  width: 44px;',
      '  height: 44px;',
      '  border-radius: 4px;',
      '  background: #f0f0f0;',
      '  flex-shrink: 0;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  font-size: 18px;',
      '}',

      /* Info do produto */
      '.de-ls-info { flex: 1; min-width: 0; }',
      '.de-ls-title {',
      '  font-size: 13px;',
      '  font-weight: 500;',
      '  color: var(--color-text, #1a1a1a);',
      '  white-space: nowrap;',
      '  overflow: hidden;',
      '  text-overflow: ellipsis;',
      '  line-height: 1.35;',
      '}',
      '.de-ls-title mark {',
      '  background: none;',
      '  color: var(--color-primary, #c8102e);',
      '  font-weight: 700;',
      '}',
      '.de-ls-price {',
      '  font-size: 12px;',
      '  font-weight: 700;',
      '  color: var(--color-primary, #c8102e);',
      '  margin-top: 2px;',
      '}',

      /* Rodapé "ver todos" */
      '.de-ls-footer {',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  padding: 9px 14px;',
      '  border-top: 1px solid #f0f0f0;',
      '  font-size: 12px;',
      '  font-weight: 700;',
      '  letter-spacing: 0.04em;',
      '  text-transform: uppercase;',
      '  color: var(--color-primary, #c8102e);',
      '  font-family: var(--font-heading-family, "Oswald", sans-serif);',
      '  text-decoration: none;',
      '  transition: background 0.12s;',
      '}',
      '.de-ls-footer:hover { background: #fff5f5; }',

      /* Feedback: carregando / sem resultado */
      '.de-ls-msg {',
      '  padding: 14px;',
      '  text-align: center;',
      '  font-size: 13px;',
      '  color: #999;',
      '}',

      /* Mobile: garante que o dropdown não saia da tela */
      '@media (max-width: 768px) {',
      '  .de-ls-dropdown { left: 0; right: 0; border-radius: 4px; }',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }
  // ─────────────────────────────────────────────────────────────────────────

  // ─── BUSCA NA API ────────────────────────────────────────────────────────
  function fetchProducts(query, callback) {
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=' + CONFIG.maxResults
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title';

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        callback(null, products);
      })
      .catch(function (err) { callback(err, []); });
  }
  // ─────────────────────────────────────────────────────────────────────────

  // ─── RENDERIZAÇÃO ────────────────────────────────────────────────────────
  function renderDropdown(dropdown, products, query) {
    dropdown.innerHTML = '';

    if (!products.length) {
      dropdown.innerHTML = '<div class="de-ls-msg">Nenhum produto encontrado para <strong>' + escapeHtml(query) + '</strong></div>';
      return;
    }

    var header = document.createElement('div');
    header.className = 'de-ls-header';
    header.textContent = 'Produtos';
    dropdown.appendChild(header);

    products.forEach(function (p) {
      var imgUrl = p.featured_image && p.featured_image.url
        ? p.featured_image.url + '&width=88'
        : null;
      var price = p.price ? formatMoney(p.price) : '';
      var title = highlightMatch(p.title, query);

      var a = document.createElement('a');
      a.className = 'de-ls-item';
      a.href = '/products/' + p.handle;
      a.setAttribute('role', 'option');
      a.innerHTML =
        (imgUrl
          ? '<img class="de-ls-img" src="' + imgUrl + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
          : '<div class="de-ls-img-ph">📦</div>'
        ) +
        '<div class="de-ls-info">' +
          '<div class="de-ls-title">' + title + '</div>' +
          (price ? '<div class="de-ls-price">' + price + '</div>' : '') +
        '</div>';

      dropdown.appendChild(a);
    });

    var footer = document.createElement('a');
    footer.className = 'de-ls-footer';
    footer.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    footer.textContent = 'Ver todos os resultados →';
    dropdown.appendChild(footer);
  }
  // ─────────────────────────────────────────────────────────────────────────

  // ─── INICIALIZAÇÃO POR INPUT ──────────────────────────────────────────────
  function initInput(input) {
    // Evita dupla inicialização
    if (input.dataset.deLsInit) return;
    input.dataset.deLsInit = '1';

    // O input fica dentro de um <form>. Precisamos criar o wrapper
    // em torno do <form> (ou do próprio input) para o dropdown se posicionar corretamente.
    // Aqui envolvemos o <form> pai.
    var form = input.closest('form');
    var target = form || input;
    var parent = target.parentElement;

    var wrapper = document.createElement('div');
    wrapper.className = 'de-ls-wrapper';
    parent.insertBefore(wrapper, target);
    wrapper.appendChild(target);

    var dropdown = document.createElement('div');
    dropdown.className = 'de-ls-dropdown';
    dropdown.setAttribute('role', 'listbox');
    wrapper.appendChild(dropdown);

    var activeIdx = -1;

    function show() { dropdown.classList.add('de-ls-open'); }
    function hide() { dropdown.classList.remove('de-ls-open'); activeIdx = -1; }

    function getItems() {
      return Array.from(dropdown.querySelectorAll('.de-ls-item'));
    }

    function setActive(idx) {
      var items = getItems();
      items.forEach(function (el, i) {
        el.classList.toggle('de-ls-active', i === idx);
      });
      activeIdx = idx;
    }

    var doSearch = debounce(function (query) {
      if (query.length < CONFIG.minChars) { hide(); return; }

      dropdown.innerHTML = '<div class="de-ls-msg">Buscando...</div>';
      show();

      fetchProducts(query, function (err, products) {
        if (err) {
          dropdown.innerHTML = '<div class="de-ls-msg">Erro ao buscar. Tente novamente.</div>';
          return;
        }
        renderDropdown(dropdown, products, query);
        show();
      });
    }, CONFIG.debounceMs);

    // Digitar
    input.addEventListener('input', function () {
      doSearch(input.value.trim());
    });

    // Navegação por teclado
    input.addEventListener('keydown', function (e) {
      var items = getItems();
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setActive(Math.min(activeIdx + 1, items.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(Math.max(activeIdx - 1, 0));
      } else if (e.key === 'Enter' && activeIdx >= 0) {
        e.preventDefault();
        items[activeIdx].click();
      } else if (e.key === 'Escape') {
        hide();
        input.blur();
      }
    });

    // Reabrir se já tem conteúdo e ganhar foco
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= CONFIG.minChars && dropdown.children.length) show();
    });

    // Fechar ao clicar fora
    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) hide();
    });
  }
  // ─────────────────────────────────────────────────────────────────────────

  // ─── INICIALIZAÇÃO PRINCIPAL ──────────────────────────────────────────────
  function init() {
    injectStyles();

    // Seletores exatos dos seus arquivos Liquid
    var selectors = [
      '.header__search-input',         // header-desktop.liquid
      '.header__mobile-search-input',  // header-mobile.liquid
    ];

    var found = 0;
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (input) {
        initInput(input);
        found++;
      });
    });

    if (found === 0) {
      console.warn('[Destaque Live Search] Nenhum campo de busca encontrado. Verifique se os arquivos header-desktop.liquid e header-mobile.liquid estão carregados.');
    } else {
      console.log('[Destaque Live Search] Ativo em ' + found + ' campo(s).');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // ─────────────────────────────────────────────────────────────────────────

})();